<template>
  <div>
    <van-loading class="loading" color="#1989fa" vertical>
      {{
        message || "文档加载中..."
      }}
    </van-loading>
  </div>
</template>

<script>
export default {
  props: {
    message: { default: "", type: String }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.loading {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 10;
}
</style>
